export const KeyCodes = {
  escape: 27,
  enter: 13,
};
